export const PROJECT_STATE_DRAFT = 0
export const PROJECT_STATE_PUBLISHED = 1
